import { useCallback, useEffect } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

import { ErrorReportingProvider } from '@highlight-cp/core-ui';
import {
  APP_ERROR_OUTCOME,
  reportClientError,
  setClientErrorUserId,
} from '@highlight-cp/metrics/client';
import { useGetUser } from 'features/account/use-get-user';

export function ClientErrorReportingProvider({ children }: { children: ReactNode }) {
  const onError = useCallback((error: Error, _errorInfo: ErrorInfo) => {
    reportClientError({
      outcome: APP_ERROR_OUTCOME.REACT_BOUNDARY,
      message: error.message,
      errorName: error.name,
    });
  }, []);

  return <ErrorReportingProvider onError={onError}>{children}</ErrorReportingProvider>;
}

export function SyncClientErrorUserId() {
  const { account, status } = useGetUser();

  useEffect(() => {
    const id = status === 'authenticated' && account?.id ? account.id : null;
    setClientErrorUserId(id);

    return () => {
      setClientErrorUserId(null);
    };
  }, [account?.id, status]);

  return null;
}
